import React from 'react';
import { authRoles } from 'app/auth';

export const HeidiAppsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: [...authRoles.user, ...authRoles.instructor, ...authRoles.participant, ...authRoles.demo],
	routes: [
		{
			path: '/heidi-apps',
			component: React.lazy(() => import('./HeidiApps'))
		}
	]
};
